const standardKeyExample = "238af42bca2894hf7b47cd4323";
const emailExample = "username@domain.com";
const activationKeyExample = "12345678-abcd-efgh-ijkl-1234567890ab";
const passwordExample = "Password";
const rsaPrivateKey =
  "-----BEGIN RSA PRIVATE KEY----- MIIBOgIBAAJBAKj34GkxFhD90vcNLYLInFEX6Ppy1tPf9Cnzj4p4WGeKLs1Pt8QuKUpRKfFLfRYC9AIKjbJTWi+CqvjW";
const certificateExample =
  "-----BEGIN CERTIFICATE----- MIIDXTCCAkWgAwIBAgIJAO2bnzWDT7tBMA0GCSqGSIb3DQEBCwUAMEUxCzAJBgNV";
const amazonKeyExample = "AKIAIOSFODNN7EXAMPLE";

// These are used across different placeholders, and reused

const INPUT_PLACEHOLDERS: { [key: string]: string } = {
  host: "localhost",
  password: passwordExample,
  secret: passwordExample,
  clientSecret: passwordExample,
  clientId: "1234567890",
  apiToken: standardKeyExample,
  accessToken: standardKeyExample,
  refreshToken: standardKeyExample,
  keyId: "2X9A4B6C7D",
  username: "john",
  email: emailExample,
  token: standardKeyExample,
  accountId: "1234567890",
  name: "John Smith",
  apiKey: standardKeyExample,
  apiSecret: standardKeyExample,
  port: "5432",
};

export {
  INPUT_PLACEHOLDERS,
  activationKeyExample,
  amazonKeyExample,
  certificateExample,
  emailExample,
  passwordExample,
  rsaPrivateKey,
  standardKeyExample,
};
